import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "doc-progress"
}
const _hoisted_2 = { class: "doc-progress__bar" }
const _hoisted_3 = ["aria-valuenow"]
const _hoisted_4 = { class: "doc-progress__num" }

import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    doc: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.doc.progress > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            "aria-valuenow": __props.doc.progress,
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            class: "doc-progress__now",
            style: _normalizeStyle({ '--doc-progress': __props.doc.progress })
          }, null, 12, _hoisted_3)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.doc.progress) + "% read", 1)
      ]))
    : _createCommentVNode("", true)
}
}

})